module.exports = __webpack_public_path__ + "static/media/AI_10.49d1813b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_10.png
// module id = 125
// module chunks = 0